import { render, staticRenderFns } from "./confirmDelete.popup-chunk.vue?vue&type=template&id=d6a97d70"
import script from "./confirmDelete.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmDelete.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports